module.exports = __webpack_public_path__ + "static/img/01.b051231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/01.jpg
// module id = gmir
// module chunks = 0